import React from 'react';
import Box from '@mui/material/Box';

const defaltColor = `rgba(22, 177, 255, 0.12)`;

export default function SalesTableRow(props) {
  const { children } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        '&:last-child': {
          borderBottom: 'none'
        },
        bgcolor: defaltColor
      }}
    >
      {children}
    </Box>
  );
}
